import { web3 } from "./account";
import { connectWallet } from "./account";
import { erc20ABI, nftPresaleABI } from "./abi";
import { usdtContractAddress , nftPresaleContractAddress} from "./contracts";
import MyCountDown from "../GetYourNft/CountDown/CountDown";
const UINT256_MAX = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
const nftContract = new web3.eth.Contract(nftPresaleABI, nftPresaleContractAddress);
const usdtContract = new web3.eth.Contract(erc20ABI, usdtContractAddress);


export const getTotalMinted = async () => {
    try {
        const call =  parseFloat(await nftContract.methods.getAllMint().call()).toFixed(0);
          const value = await Promise.all([call]);
          return value;
    } catch (error) {
        console.log(error);
    }
}

export const getuserPurchase = async (aact) => {
    //const account = await connectWallet();
    try {
        const call = parseFloat(await nftContract.methods.purchasedNft(aact).call()).toFixed(0);
        const value = Promise.all([call]);
        return value;
    } catch (error) {
        console.log(error);
    }
}

export const getUSDTbalance = async (aact) => {
   // const account = await connectWallet();
    try {
        const call = parseFloat(web3.utils.fromWei(await usdtContract.methods.balanceOf(aact).call()), "ether").toFixed(2);
        return await Promise.all([call]);
    } catch (error){
        console.log(error);
    }
}

export const getAllocation = async (aact) => {
   // const account = await connectWallet();
    try {
        const call = parseFloat(web3.utils.fromWei(await usdtContract.methods.allowance(aact, nftPresaleContractAddress).call()), "ether").toFixed(2);
        return await Promise.all([call]);
    } catch (error) {
        console.log(error)
    }
}

export const approveUSDT = async (aact) => {
   // const account =  await connectWallet();
    try {
        await usdtContract.methods.approve(nftPresaleContractAddress,UINT256_MAX).send({
            from : aact,
        });

    } catch(error) {
        console.log(error)
    }
}

export const mintNFT = async (amount , referral, aact) => {
   // const account =  await connectWallet();
    try {
        await nftContract.methods.mint(amount , referral).send({
            from : aact,
        })
    } catch (error) {
        console.log(error)
    }
}